import { TailwindWrapper } from "../TailwindWrapper/TailwindWrapper";
import { Icon, Text } from "@virkesborsen/ui-component-library";
import MediaSelector from "../editor/fields/MediaSelector";
import LayoutSelector from "../editor/fields/LayoutSelector";
import React from "react";

const FeatureCards = (props) => {
  const firstSpan =
    props.layout === "oneThirdTwoThirds" ? "lg:col-span-1" : "lg:col-span-2";
  const secondSpan =
    props.layout === "oneThirdTwoThirds" ? "lg:col-span-2" : "lg:col-span-1";

  const leftCardProps = {
    src:
      props.LeftCardSrc ||
      (props.layout === "oneThirdTwoThirds"
        ? "https://placehold.co/400x340"
        : "https://placehold.co/820x340"),
    alt: props.LeftCardAlt,
    title: props.LeftCardTitle,
    text: props.LeftCardText,
    url: props?.LeftCardLink,
    widthClass: firstSpan,
  };

  const rightCardProps = {
    src:
      props.RightCardSrc ||
      (props.layout === "oneThirdTwoThirds"
        ? "https://placehold.co/820x340"
        : "https://placehold.co/400x340"),
    alt: props.RightCardAlt,
    title: props.RightCardTitle,
    text: props.RightCardText,
    url: props?.RightCardLink,
    widthClass: secondSpan,
  };

  const Card = ({ src, alt, title, text, url, widthClass = "" }) => {
    const Container = url ? "a" : "div";
    return (
      <Container
        className={`flex h-full w-full flex-col overflow-hidden rounded-xl ${widthClass} ${
          url ? "cursor-pointer" : ""
        }`}
        href={url ? url : undefined}
      >
        <div className="relative bg-gray-100">
          <img
            alt={alt}
            src={src}
            className="h-[366px] w-full object-cover object-center"
          />
        </div>
        <div className="flex flex-1 flex-col gap-2 border-t border-gray-200 bg-[#f7f7f7] p-6">
          <Text tw variant="text-lg/leading-normal/medium">
            {title}
          </Text>
          <Text
            tw
            variant="text-base/leading-normal/normal"
            className="mt-2 text-[#737373]"
          >
            {text}
          </Text>
        </div>
      </Container>
    );
  };

  return (
    <TailwindWrapper>
      <section className="w-full py-3 bg-white container">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:items-stretch lg:auto-rows-fr">
          <Card {...leftCardProps} />
          <Card {...rightCardProps} />
        </div>
      </section>
    </TailwindWrapper>
  );
};

FeatureCards.defaultProps = {
  layout: "oneThirdTwoThirds",
  LeftCardSrc: "",
  LeftCardAlt: "Feature image",
  LeftCardTitle: "Feature title 1",
  LeftCardText:
    "Shortly describe how this feature solves a specific user problem. Focus on benefits rather than features.",
  LeftCardLink: undefined,
  RightCardSrc: "",
  RightCardAlt: "Feature image",
  RightCardTitle: "Feature title 2",
  RightCardText:
    "Shortly describe how this feature solves a specific user problem. Focus on benefits rather than features.",
  RightCardLink: undefined,
};

FeatureCards.fields = {
  layout: {
    type: "custom",
    label: "Layout",
    render: ({ onChange, value }) => {
      return <LayoutSelector onChange={onChange} value={value} />;
    },
  },
  LeftCardSrc: {
    type: "custom",

    render: ({ name, onChange, value }) => (
      <MediaSelector
        name={name}
        label="Left Image Source"
        type={"img"}
        onChange={onChange}
        value={value}
      />
    ),
  },
  LeftCardAlt: {
    type: "text",
    label: "Left Image Alt Text",
  },
  LeftCardTitle: {
    type: "text",
    label: "Left Title",
  },
  LeftCardText: {
    type: "textarea",
    label: "Left Description",
  },
  LeftCardLink: {
    type: "text",
    label: "Left Link",
  },
  RightCardSrc: {
    type: "custom",
    render: ({ name, onChange, value }) => (
      <MediaSelector
        name={name}
        label="Right Image Source"
        type={"img"}
        onChange={onChange}
        value={value}
      />
    ),
  },
  RightCardAlt: {
    type: "text",
    label: "Right Image Alt Text",
  },
  RightCardTitle: {
    type: "text",
    label: "Right Title",
  },
  RightCardText: {
    type: "textarea",
    label: "Right Description",
  },
  RightCardLink: {
    type: "text",
    label: "Right Link",
  },
};

export default FeatureCards;
